import React from "react";
import { ArrowLeft, Lightbulb, Building2, Rocket } from "lucide-react";
import { useNavigate } from "react-router-dom";
export function WhoIsItFor() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800" data-id="element-574">
      <nav className="fixed top-0 w-full bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 z-50" data-id="element-575">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-576">
          <div className="flex items-center justify-between h-16" data-id="element-577">
            <button onClick={() => navigate("/")} className="text-gray-600 hover:text-gray-900 flex items-center" data-id="element-578">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-579" />
              Back to Home
            </button>
            <div onClick={() => navigate("/")} className="text-xl font-bold text-blue-600 cursor-pointer hover:text-blue-700 transition-colors" data-id="element-580">
              <span data-id="element-581">MVP</span>
              <span data-id="element-582">Hub.co</span>
            </div>
          </div>
        </div>
      </nav>
      <main className="pt-32 pb-24" data-id="element-583">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-584">
          <div className="text-center mb-20" data-id="element-585">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-586">
              Who is it for?
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-587">
              We work with innovators of all backgrounds who share one common
              trait: the drive to turn ideas into reality.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto" data-id="element-588">
            {[{
            title: "Startup Dreamer",
            description: "Aspiring founder with a big idea but limited resources, ready to take the first step.",
            icon: Lightbulb,
            gradient: "from-blue-600 to-blue-400",
            shadowColor: "rgba(37, 99, 235, 0.1)"
          }, {
            title: "Business Innovator",
            description: "A professional looking to build and launch an idea within their existing business or job.",
            icon: Building2,
            gradient: "from-purple-600 to-purple-400",
            shadowColor: "rgba(147, 51, 234, 0.1)"
          }, {
            title: "Serial Entrepreneur",
            description: "Experienced founder eager to validate their next venture with speed and precision.",
            icon: Rocket,
            gradient: "from-green-600 to-green-400",
            shadowColor: "rgba(22, 163, 74, 0.1)"
          }].map((persona, index) => <div key={index} className="relative group" data-id="element-589">
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
              background: `linear-gradient(to right, ${persona.shadowColor}, transparent)`
            }} data-id="element-590" />
                <div className="relative bg-white dark:bg-gray-800 p-8 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm transition-all duration-300 group-hover:shadow-xl group-hover:scale-[1.02]" data-id="element-591">
                  <div className="space-y-6" data-id="element-592">
                    <div className={`bg-gradient-to-r ${persona.gradient} w-14 h-14 rounded-xl flex items-center justify-center`} data-id="element-593">
                      <persona.icon className="w-7 h-7 text-white" data-id="element-594" />
                    </div>
                    <div data-id="element-595">
                      <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-3" data-id="element-596">
                        {persona.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed" data-id="element-597">
                        {persona.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="text-center mt-20" data-id="element-598">
            <button onClick={() => navigate("/")} className="bg-gradient-to-r from-blue-600 to-blue-500 text-white px-10 py-5 rounded-xl text-lg font-semibold hover:from-blue-700 hover:to-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-599">
              Start Your Free Assessment
            </button>
          </div>
        </div>
      </main>
    </div>;
}